export default "__VITE_ASSET__79cc5eec__"